import Vue from 'vue'
import Router from 'vue-router'

import OpusDetail from 'pages/opus/Opus'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/mobile.php/Public/weibo/id/:opusId',
      name: 'WeiboDetail',
      component: OpusDetail
    },
    {
      path: '/opus/:opusId',
      name: 'OpusDetail',
      component: OpusDetail
    }
  ]
})
